module.exports = __webpack_public_path__ + "img/thumbnail_ArcticFox_f_albino.fe3e0a8c.png";